import User from 'store/models/User';
import Overlay from 'store/models/Overlay';
import Scene from 'store/models/Scene';
import Stats from 'store/models/Stats';
import Stream from 'store/models/Stream';
import Twitch from 'store/models/Twitch';
import YouTube from 'store/models/YouTube';
import Channel from 'store/models/Channel';
import Session from 'store/models/Session';
import Account from 'store/models/Account';
import Campaign from 'store/models/Campaign';
import Link from 'store/models/Link';
import Brand from 'store/models/Brand';
import Team from 'store/models/Team';
import Game from 'store/models/Game';

export const models = {
  User,
  Overlay,
  Scene,
  Stats,
  Stream,
  Twitch,
  YouTube,
  Channel,
  Account,
  Session,
  Campaign,
  Link,
  Brand,
  Team,
  Game,
}
export default models;
